module.exports = __webpack_public_path__ + "static/media/gameLandscape.5f14d2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameLandscape.png
// module id = 861
// module chunks = 0